import { Component } from "react";
import { api } from "@/lib/api";

// Filet global : aucune exception de rendu ne laisse un écran blanc. L'erreur est journalisée côté serveur (sans donnée patient)
// et le filet se réarme dès que l'utilisateur navigue ailleurs.
export class ErrorBoundary extends Component {
  state = { error: null, path: typeof window !== "undefined" ? window.location.pathname : "" };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    console.error("SanitDocs UI error:", error, info?.componentStack);
    try {
      api.post("/client-errors", {
        message: String(error?.message || error).slice(0, 500),
        stack: String(error?.stack || "").slice(0, 2000),
        component_stack: String(info?.componentStack || "").slice(0, 2000),
        path: window.location.pathname, user_agent: navigator.userAgent.slice(0, 200),
        standalone: window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true,
      }).catch(() => {});
    } catch (_) {}
  }
  componentDidUpdate() {
    if (this.state.error && window.location.pathname !== this.state.path) this.setState({ error: null, path: window.location.pathname });
  }
  retry = () => this.setState({ error: null, path: window.location.pathname });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="app-error-boundary" className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
        <div className="max-w-sm w-full bg-white rounded-2xl border border-slate-200 p-6 shadow-sm text-center space-y-4">
          <p className="font-heading font-bold text-brand-900 text-lg">Une erreur est survenue</p>
          <p className="text-sm text-slate-500">L'application a rencontré un problème d'affichage. Vos données ne sont pas perdues.</p>
          <button data-testid="app-error-retry" onClick={this.retry}
            className="w-full py-3 rounded-2xl bg-brand-800 text-white font-bold active:scale-[0.98] transition-transform">
            Réessayer
          </button>
          <button data-testid="app-error-reload" onClick={() => window.location.reload()}
            className="w-full py-3 rounded-2xl bg-slate-100 text-slate-700 font-bold active:scale-[0.98] transition-transform">
            Recharger l'application
          </button>
        </div>
      </div>
    );
  }
}
